import React, { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { NavigationContext } from '@annunciate/ui';
import { isEntitledToItemFromClientCache, useChannelQuery, } from '@annunciate/query';
import { PlaybackEvent, PlaybackEventEmitter, useUserUUID, } from '@annunciate/core';
import { DEEPLINK_SCHEME, resolveDeepLink } from '../utils/navigation';
import { resolveRouteFromItem } from '../utils';
export const NavigationContextProvider = ({ children, onNavigate }) => {
    const client = useQueryClient();
    const uuid = useUserUUID();
    const { data } = useChannelQuery();
    const isQuickPlayEnabled = data?.channel?.settings?.isQuickPlayEnabled;
    const onNavigateToItem = useCallback((item) => {
        if (item.__typename === 'Slide') {
            if (!item.link)
                return;
            if (item.link.startsWith(window.location.origin) ||
                item.link.startsWith('/')) {
                onNavigate(item.link);
            }
            else if (item.link.startsWith(DEEPLINK_SCHEME)) {
                onNavigate(resolveDeepLink(item.link));
            }
            else {
                window.open(item.link, '_blank');
            }
        }
        else if (item.__typename === 'Content' &&
            item.asset &&
            isEntitledToItemFromClientCache({
                uuid,
                client,
                item: item,
            }) === true &&
            isQuickPlayEnabled === true) {
            PlaybackEventEmitter.emit(PlaybackEvent.START, { content: item });
        }
        else {
            const route = resolveRouteFromItem(item);
            onNavigate(route);
        }
    }, [onNavigate, isQuickPlayEnabled, uuid, client]);
    return (React.createElement(NavigationContext.Provider, { value: {
            onNavigateToItem,
            onNavigate,
        } }, children));
};
//# sourceMappingURL=NavigationContextProvider.js.map